import React, {Component} from 'react';
import {connect} from 'react-redux';

/*** components ***/
import {VerticalArrows} from "../../../../components/buildcomponent/VerticalArrows/VerticalArrows";
import {HorizontalArrows} from "../../../../components/buildcomponent/HorizontalArrows/HorizontalArrows";

/*** helpers ***/
import usingIE from '../../../../helpers/usingIE';

/***styles ***/
import './style.css';

class DrawArea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            heightOfOuterArea: usingIE ? ((window.innerWidth - 375) / (1920 - 375) * (474 - 154) + 154 + "px") : "calc( (100vw - 375px)/(1920 - 375) * (474 - 154) + 154px)",
            gridTemplateRows: `1fr ${usingIE ? ((window.innerWidth - 375) / (1920 - 375) * (474 - 154) + 154 + "px") : "calc( (100vw - 375px)/(1920 - 375) * (474 - 154) + 154px)"} 1fr`
        };
    }

    calculateAreaHeight(width, length) {
        let drawAreaHeight = document.body.getElementsByClassName("inner-area")[0].clientWidth;
        if (+length > +width) {
            drawAreaHeight = drawAreaHeight / 1.4;
        } else if (+length < +width) {
            drawAreaHeight = drawAreaHeight * 1.25;
        }
        return drawAreaHeight;
    }

    componentWillReceiveProps(nextProps) {
        // if(+nextProps.length === +nextProps.width){
        //     let drawAreaWidth  = document.body.getElementsByClassName("outer-area")[0].clientWidth;
        //     this.setState ({
        //         gridTemplateRows: `1fr ${drawAreaWidth}px 1fr`
        //     })
        // }else if (+nextProps.length !== +nextProps.width){
        //     this.setState ({
        //         gridTemplateRows: `1fr ${usingIE ? ((window.innerWidth - 375)/(1920 - 375) * (474 - 154) + 154 + "px") : "calc( (100vw - 375px)/(1920 - 375) * (474 - 154) + 154px)"} 1fr`

        //     })
        // }

        // calculating rectangle ratio
        this.setState({innerAreaStyle: {height: this.calculateAreaHeight(nextProps.width, nextProps.length)}});
    }

    componentDidMount() {
        // if(+this.props.length === +this.props.width){
        //     let drawAreaWidth  = document.body.getElementsByClassName("outer-area")[0].clientWidth;
        //     this.setState({
        //         gridTemplateRows: `1fr ${drawAreaWidth}px 1fr`
        //     })
        // }

        // calculating rectangle ratio
        window.addEventListener('load', () => this.setState({innerAreaStyle: {height: this.calculateAreaHeight(this.props.width, this.props.length)}}));
    }

    render() {
        return (
            <div className="draw-area-step-1">
                <div className="side-c-header">
                    <span className="side-title side-c-title">Ansicht C</span>
                    <span className="left-arrow-step-1"/>
                </div>
                <div className="sides-wrapper">
                    <div className="side-a-header">
                        <span className="side-title">Ansicht A</span>
                        <span className="down-arrow"/>
                    </div>
                    <div className="outer-area">
                        <div className="inner-area" style={{...this.state.innerAreaStyle}}>
                            <HorizontalArrows
                                isInput={true}
                                dataInputName={"length"}
                                step={5}
                                changeInputValue={this.props.changeInputValue}
                                value={this.props.length}
                            />
                            <VerticalArrows
                                isInput={true}
                                marginLeft={"20%"}
                                dataInputName={"width"}
                                step={5}
                                changeInputValue={this.props.changeInputValue}
                                value={this.props.width}
                            />
                        </div>
                        <div className="wall-width">
                            {/*
                            <HorizontalArrows
                                isInput={false}
                                maxArrowWidth={"14.7"}
                                minArrowWidth={"4.63"}
                                maxArrowHeight={"7.35"}
                                minArrowHeight={"2.315"}
                                bottom={"10%"}
                            />
                            */}
                        </div>
                    </div>
                    <div className="side-b-header">
                        <span className="up-arrow"/>
                        <span className="side-title">Ansicht B</span>
                        {/*
                            <input
                                type="number"
                                data-input-name = {"wallWidth"}
                                className={"input-side-b-step-1"}
                                min = {0}
                                step = {5}
                                value = {this.props.wallWidth}
                                readOnly={this.props.wallWidth && !this.props.changeInputValue}
                                onChange={this.props.changeInputValue}/>
                            */}
                    </div>
                </div>
                <div className="side-d-header">
                    <span className="right-arrow-step-1"/>
                    <span className="side-title side-d-title">Ansicht D</span>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        wallWidth: state.buildValues.wallWidth,
        width: state.buildValues.width,
        length: state.buildValues.length,
    };
};

const mapStateToDispatch = {};

export default connect(mapStateToProps, mapStateToDispatch)(DrawArea);


// WEBPACK FOOTER //
// ./src/containers/steps/step1/DrawArea/index.js